import React, { useEffect, useState } from "react";
import { CLAUDE_CONNECTOR_HELP_URL } from "../constants/helpUrls";

const REDIRECT_FALLBACK_DELAY_MS = 5000;

const ClaudeConnectorArticleRedirect: React.FC = () => {
  const [showFallbackLink, setShowFallbackLink] = useState(false);

  useEffect(() => {
    try {
      window.location.replace(CLAUDE_CONNECTOR_HELP_URL);
    } catch {
      setShowFallbackLink(true);
      return;
    }

    const fallbackTimeoutId = window.setTimeout(() => {
      setShowFallbackLink(true);
    }, REDIRECT_FALLBACK_DELAY_MS);

    return () => window.clearTimeout(fallbackTimeoutId);
  }, []);

  if (!showFallbackLink) return null;

  return (
    <main className="min-h-screen bg-white p-6 text-gray-900 dark:bg-black dark:text-white">
      <a href={CLAUDE_CONNECTOR_HELP_URL} className="text-rp-amber underline">
        Open the official Plutus Claude connector guide
      </a>
    </main>
  );
};

export default ClaudeConnectorArticleRedirect;
